import Content, { IContent } from "@/model/Content/Content"
import Image from "@/model/Image/Image"

export interface ILiheContent extends IContent {
    getLiheId(): number
    getLiheName(): string
    getStationId(): string
    getStationName(): string
    getImages(): Image[]
    getCountryId(): string
    getCountryName(): string
    getRegionId(): string
    getRegionName(): string
    getCriterias(): string[]
    getIsHaveCriteria(criteria: string): boolean
}

class LiheContent extends Content implements ILiheContent {
    private liheId: number
    private liheName: string
    private stationId: string
    private stationName: string
    private images: Image[] = []
    private countryId: string
    private countryName: string
    private regionId: string
    private regionName: string
    private criterias: string[]
    private criteriasSet: Set<string> = new Set()

    constructor(
        liheId: number,
        liheName: string,
        stationId: string,
        stationName: string,
        pictureLodging: LooseObject[] | null,
        countryId: string,
        countryName: string,
        regionId: string,
        regionName: string,
        criterias: string[],
    ) { // TODO when content arrives, register here and pass to super
        super()
        this.liheId = liheId
        this.liheName = liheName
        this.stationId = stationId
        this.stationName = stationName
        this.countryId = countryId
        this.countryName = countryName
        this.regionId = regionId
        this.regionName = regionName
        this.criterias = criterias
        this.criteriasSet = new Set(criterias)
        this._processPictureLodging(pictureLodging)
    }

    private _processPictureLodging(imgObjArr: LooseObject[] | null): void {
        this.images = []
        if (!imgObjArr) return
        imgObjArr.forEach((imgObj) => {
            const { img, imgSmall, imgMedium, imgLarge, imgXL, imgNumber } = imgObj
            const image = new Image(img, imgSmall, imgMedium, imgLarge, imgXL, imgNumber)
            this.images.push(image)
        })
    }

    public getLiheId(): number {
        return this.liheId
    }
    public getLiheName(): string {
        return this.liheName
    }
    public getStationId(): string {
        return this.stationId
    }
    public getStationName(): string {
        return this.stationName
    }
    public getCountryId(): string {
        return this.countryId
    }
    public getCountryName(): string {
        return this.countryName
    }
    public getRegionId(): string {
        return this.regionId
    }
    public getRegionName(): string {
        return this.regionName
    }
    public getImages(): Image[] {
        return this.images
    }
    public getCriterias(): string[] {
        return this.criterias
    }
    public getIsHaveCriteria(criteria: string): boolean {
        return this.criteriasSet.has(criteria)
    }

}

export default LiheContent